<template>
  <div>
    <div :class="thisCellUrl ? 'clickable' : ''" @click="navigateToLink">{{params.valueFormatted}}</div>
  </div>
</template>

<script>

  export default {
    name: 'LinkableCell',
    components: {
     
    },
    props: {

    },
    data: function () {
    
    },
    computed: {
      thisCellUrl() { return this.params.data[this.params.colDef.field.replace('Amount', 'Url')]; }
    },
    methods: {
      navigateToLink(e) {
        if (this.thisCellUrl) {
          window.open(this.thisCellUrl, '_blank');
          if (e && e.preventDefault) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }
      }
    },
    async mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .clickable:hover {
    color: var(--v-resBlue-darken1);
    text-decoration:underline;
    cursor:pointer;
  }
</style>
